module.exports = [
	// Listed in order of usage preference
	require('./localStorage'),
	require('./oldFF-globalStorage'),
	require('./oldIE-userDataStorage'),
	require('./cookieStorage'),
	require('./sessionStorage'),
	require('./memoryStorage')
]



//////////////////
// WEBPACK FOOTER
// ./~/store/storages/all.js
// module id = 1019
// module chunks = 0